import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { show } from '@intercom/messenger-js-sdk';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Button, Divider, IconButton, Popover, Typography } from '@mui/material';

import { PATH } from '~/constants/route-path';
import { useAppSelector } from '~/hooks/useRedux';
import { googleAnalytics } from '~/services/google-analytics-service';
import { getLoggedInUser } from '~/store/reducers/account/selector';
import { COLORS } from '~/styles/colors';
import { logOut } from '~/utils/common';

function Header() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: accountData } = useAppSelector(getLoggedInUser);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? 'setting-popover' : undefined;

  const handleSettingsIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClick = () => {
    navigate(PATH.SETTINGS);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleLogOutClick = async () => {
    await logOut();
    googleAnalytics.events.logOut();
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ pt: 3 }}>
      <Button
        variant="text"
        sx={{ color: COLORS.black06, fontSize: 15, textTransform: 'none' }}
        size="small"
        onClick={show}
      >
        {t('buttons:supp')}
      </Button>
      <IconButton size="small" onClick={handleSettingsIconClick}>
        <SettingsIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box width={220} sx={{ lineBreak: 'anywhere' }}>
          <Button
            variant="text"
            sx={{ color: COLORS.black06, fontSize: 15, m: 2 }}
            size="small"
            onClick={() => handleSettingsClick()}
            startIcon={<SettingsIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />}
          >
            {t('settings:settingsTitle')}
          </Button>
          <Divider mb={2} />
          <Box m={2}>
            <Typography fontSize={16}>{`${accountData?.firstName || ''} ${accountData?.lastName || ''}`}</Typography>
            <Typography fontSize={14} sx={{ color: COLORS.black06 }}>
              {accountData?.email || ''}
            </Typography>
            <Button
              variant="text"
              sx={{ color: COLORS.black06, fontSize: 15, mt: 3 }}
              size="small"
              onClick={() => handleLogOutClick()}
              startIcon={<LogoutIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />}
            >
              {t('buttons:logOutBtn')}
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}

export default Header;
